import { render } from "./CadastroAssunto.vue?vue&type=template&id=d1510cee&scoped=true"
import script from "./CadastroAssunto.vue?vue&type=script&lang=js"
export * from "./CadastroAssunto.vue?vue&type=script&lang=js"

import "./CadastroAssunto.vue?vue&type=style&index=0&id=d1510cee&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1510cee"]])

export default __exports__